import { ChangeDetectionStrategy, Component } from '@angular/core';
import { input } from '@angular/core';
import { BypassSecurityPipe } from '@ebeihilfe/core';
import { EinreichungStep } from '@ebeihilfe/einreichung-old';
import { StepsSvgComponent } from '@ebeihilfe/web-shared/web-svgs/steps/steps.component';
import { TranslateModule } from '@ngx-translate/core';

export const numberToText: { [key: number]: string } = {
  1: 'one',
  2: 'two',
  3: 'three',
};

@Component({
  selector: 'portal-single-step',
  templateUrl: './single-step.component.html',
  styleUrls: ['./single-step.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StepsSvgComponent, TranslateModule, BypassSecurityPipe],
})
export class SingleStepComponent {
  public currentStep = input<EinreichungStep>();
  public stepActive = input<boolean>();
  public stepDone = input<boolean>();
  public stepNumber = input<keyof typeof numberToText>();

  public get writtenNumber(): string {
    return numberToText[this.stepNumber()];
  }
}
